import React from 'react';
import AddressHelper from '@src/components/Elements/AddressHelper/AddressHelper';
import { Link } from 'react-router-dom';
export default props => {
  return (
    <div>
      {props.link !== undefined ? (
        <Link to={`/units/${props.id}`}>{props.owner}</Link>
      ) : (
        props.owner
      )}
      <br />
      {props.mailing_address_line_1 !== null &&
        props.mailing_address_line_1.length > 0 && (
          <React.Fragment>
            {props.mailing_address_line_1}
            {props.mailing_address_line_2 !== null &&
              props.mailing_address_line_2.length > 0 && (
                <React.Fragment>
                  ,&nbsp;{props.mailing_address_line_2}
                </React.Fragment>
              )}
            <br />
          </React.Fragment>
        )}
      <AddressHelper
        city={props.mailing_city}
        state={props.mailing_state}
        zip_code={props.mailing_zip_code}
        address_line_1={null}
        address_line_2={null}
      />
      <br />
      {props.mailing_phone !== null && props.mailing_phone !== '' && (
        <div>Phone: {props.mailing_phone}</div>
      )}
      {props.mailing_email !== null && props.mailing_email !== '' && (
        <div>Email: {props.mailing_email}</div>
      )}
    </div>
  );
};
